import { gql } from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountMembersQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  accountMembersFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.AccountMembersFiltersInput>;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
}>;

export type GetAccountMembersQueryResult = { __typename?: 'Query' } & {
  accountMembers?: GraphQLTypes.Maybe<
    { __typename?: 'AccountMemberConnection' } & Pick<GraphQLTypes.AccountMemberConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<
              GraphQLTypes.AccountMember,
              'canSwitchAccounts' | 'email' | 'firstName' | 'fullName' | 'id' | 'isProfileCompleted' | 'lastName' | 'phoneNumber'
            > & {
                assignedRoles: Array<
                  { __typename?: 'AccountUserGroup' } & Pick<GraphQLTypes.AccountUserGroup, 'name' | 'userGroupId'>
                >;
                businessUnits: Array<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
                locations: Array<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id' | 'name'>>;
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetAccountMembersDocument = gql`
  query getAccountMembers(
    $accountId: String!
    $accountMembersFiltersInput: AccountMembersFiltersInput
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    accountMembers(
      accountId: $accountId
      accountMembersFiltersInput: $accountMembersFiltersInput
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      nodes {
        assignedRoles {
          name
          userGroupId
        }
        businessUnits {
          id
          tradingName
        }
        canSwitchAccounts
        email
        firstName
        fullName
        id
        isProfileCompleted
        lastName
        locations {
          id
          name
        }
        phoneNumber
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;
